import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/** What each metric means, in the words a clinic owner would use. */
const METRIC_HINTS: Record<string, string> = {
  CPC: 'Average cost of one click.',
  CPM: 'Cost per 1,000 views.',
  Clicks: 'Every click on the ad, not just link clicks.',
  Frequency: 'Average number of times each person saw the ad.',
  CPL: 'Cost per lead: amount spent divided by leads.',
  Leads: 'Leads Meta reports, from forms and your website.',
  'Cost per lead': 'Amount spent divided by leads.',
  'Views (impressions)': 'Times the ad was shown on screen.',
  Views: 'Times the ad was shown on screen.',
  Reach: 'People who saw the ad at least once.',
  CTR: 'Share of views that led to a click.',
  Spent: 'Amount spent in this period.',
  Budget: 'Daily or lifetime budget set on the campaign.',
};

/** A metric's name, explained on hover or keyboard focus. */
export function MetricLabel({ label }: { label: string }) {
  const hint = METRIC_HINTS[label];
  if (!hint) return <>{label}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          // biome-ignore lint/a11y/noNoninteractiveTabindex: lets keyboard users reach the explanation
          tabIndex={0}
          className="cursor-help underline decoration-dotted decoration-muted-foreground/50 underline-offset-4"
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-56">{hint}</TooltipContent>
    </Tooltip>
  );
}
